import type { v2 } from '@deque/billing-service-client';
import { apiRequest } from '../../api-client';

export enum SFPeopleTypes {
  IMPLEMENTATION = 'implementation',
  ACCOUNT_EXEC = 'account_exec',
  TSA = 'tsa',
  CS_SPECIALIST = 'cs_specialist',
  ENGAGEMENT = 'engagement',
  SE = 'se'
}

export interface PeopleInfo {
  enterprise_id: string;
  [SFPeopleTypes.IMPLEMENTATION]?: string[] | null;
  [SFPeopleTypes.ACCOUNT_EXEC]?: string[] | null;
  [SFPeopleTypes.TSA]?: string[] | null;
  [SFPeopleTypes.CS_SPECIALIST]?: string[] | null;
  [SFPeopleTypes.ENGAGEMENT]?: string[] | null;
  [SFPeopleTypes.SE]?: string[] | null;
}

export interface ProductData {
  group_name: string;
  group_id: string | null;
  subscription: v2.EnterpriseSubscription;
  is_assessment: boolean;
  renew_status: string;
}

interface IdpConfig {
  hideOnLoginPage: string;
  validateSignature: string;
  samlXmlKeyNameTranformer: string;
  signingCertificate: string;
  postBindingLogout: string;
  nameIDPolicyFormat: string;
  postBindingResponse: string;
  entityId: string;
  signatureAlgorithm: string;
  useJwksUrl: string;
  authnContextComparisonType: string;
  postBindingAuthnRequest: string;
  syncMode: string;
  singleSignOnServiceUrl: string;
  wantAuthnRequestsSigned: string;
  allowedClockSkew: string;
  addExtensionsElementWithKeyInfo: string;
  principalType: string;
}

export interface IdpInfo {
  alias: string;
  displayName: string;
  internalId: string;
  providerId: string;
  enabled: boolean;
  updateProfileFirstLoginMode: string;
  trustEmail: boolean;
  storeToken: boolean;
  addReadTokenRoleOnCreate: boolean;
  authenticateByDefault: boolean;
  linkOnly: boolean;
  firstBrokerLoginFlowAlias: string;
  config: IdpConfig;
}

export interface SalesforceInfo {
  region: string;
  orgId: string;
  id: string;
  enterpriseId: string;
  enterpriseDomain: string;
  customerName: string;
  accountId: string;
  accountExecutiveCalendar: string;
}

export interface CustomerObject {
  customer_name: string;
  customer_domain: string;
  id: string;
  customer_email: string | null;
  jira_tickets: string[];
  agora_group: string;
  dqu_id: string | null;
  stripe_id: string | null;
  stripe_customer: Record<string, string>;
  stripe_email: string | null;
  auto_add_users: boolean;
  admins: string[];
  root_group?: string;
  subscription_list: Record<string, string>;
  products: Record<string, ProductData>;
  idp_active?: boolean;
  jit_active?: boolean;
  idp_info?: IdpInfo | null;
  sf_info?: SalesforceInfo | null;
  account_people_info?: PeopleInfo | null;
  cs_health?: string | null;
}

interface GetEnterpriseExplorerParams {
  token: string;
  enterpriseId: string;
}

export default {
  getEnterpriseExplorer({
    token,
    enterpriseId
  }: GetEnterpriseExplorerParams): Promise<CustomerObject> {
    return apiRequest({
      method: 'GET',
      endpoint: `/api-internal/enterprise/${enterpriseId}/explorer`,
      token
    });
  }
};
